// extracted by mini-css-extract-plugin
export default {"variant":"Variant_variant__KvCj5","varNumber":"Variant_varNumber__GF71P","varTitle":"Variant_varTitle__4t1DP"};